export class BagDisplayModel {
    public FullFrames: number = 0;
    public AccessoriesAndTools: number = 0;

    constructor(fullframes: number, accAndTools: number) {
        this.FullFrames = fullframes,
            this.AccessoriesAndTools = accAndTools;
    }
}
